import { dateToday } from "../date-today";

const development = {
  environment: "DEVELOPMENT",
  et3arrafLink: "https://www.et3arraf.com",
  API_URL: "https://admin-development-server-node-24.alkhattaba.app/",
  file_center: "http://et3-uploads.s3.amazonaws.com/",
  voiceAttachmentUrl: "https://s3-eu-west-1.amazonaws.com/et3-voice/",
  imageAttachmentUrl:
    "https://s3-eu-west-1.amazonaws.com/et3-attachment-image/",
  pictureUrl: "https://s3-eu-west-1.amazonaws.com/et3-uploads/",
  selfiePictureUrl: "https://s3-eu-west-1.amazonaws.com/et3-selfie-image/",
  env: "Staging",
  date: dateToday,
  IS_UNDER_CONSTRUCTION: false,

  version: "7.3.7",

  encryptData: "ADMIN2021ET3#ET3#",
  pass: "iamAdmin#111#Trust##Me#letMEInET3#"
};

export default development;
